export default __webpack_public_path__ + "static/media/woodworkingArea.c42626a8.jpeg";